"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_1v150z5w6p = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryForm.js";
  var hash = "4a2c469e3759e5ac772718c52c1300cf1b6a0fd2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/repository/crud/RepositoryForm.js",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 18
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "1": {
        start: {
          line: 19,
          column: 39
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "2": {
        start: {
          line: 40,
          column: 18
        },
        end: {
          line: 40,
          column: 29
        }
      },
      "3": {
        start: {
          line: 41,
          column: 34
        },
        end: {
          line: 41,
          column: 46
        }
      },
      "4": {
        start: {
          line: 42,
          column: 36
        },
        end: {
          line: 42,
          column: 46
        }
      },
      "5": {
        start: {
          line: 43,
          column: 36
        },
        end: {
          line: 43,
          column: 69
        }
      },
      "6": {
        start: {
          line: 44,
          column: 59
        },
        end: {
          line: 44,
          column: 88
        }
      },
      "7": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 53,
          column: 3
        }
      },
      "8": {
        start: {
          line: 47,
          column: 43
        },
        end: {
          line: 47,
          column: 55
        }
      },
      "9": {
        start: {
          line: 48,
          column: 22
        },
        end: {
          line: 48,
          column: 37
        }
      },
      "10": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 51,
          column: 33
        }
      },
      "11": {
        start: {
          line: 50,
          column: 29
        },
        end: {
          line: 50,
          column: 56
        }
      },
      "12": {
        start: {
          line: 51,
          column: 9
        },
        end: {
          line: 51,
          column: 33
        }
      },
      "13": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 27
        }
      },
      "14": {
        start: {
          line: 56,
          column: 25
        },
        end: {
          line: 56,
          column: 62
        }
      },
      "15": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 64,
          column: 22
        }
      },
      "16": {
        start: {
          line: 59,
          column: 18
        },
        end: {
          line: 59,
          column: 60
        }
      },
      "17": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 62,
          column: 34
        }
      },
      "18": {
        start: {
          line: 61,
          column: 21
        },
        end: {
          line: 61,
          column: 37
        }
      },
      "19": {
        start: {
          line: 62,
          column: 9
        },
        end: {
          line: 62,
          column: 34
        }
      },
      "20": {
        start: {
          line: 62,
          column: 20
        },
        end: {
          line: 62,
          column: 34
        }
      },
      "21": {
        start: {
          line: 63,
          column: 9
        },
        end: {
          line: 64,
          column: 22
        }
      },
      "22": {
        start: {
          line: 63,
          column: 25
        },
        end: {
          line: 63,
          column: 39
        }
      },
      "23": {
        start: {
          line: 64,
          column: 7
        },
        end: {
          line: 64,
          column: 22
        }
      },
      "24": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 66,
          column: 35
        }
      },
      "25": {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 78,
          column: 26
        }
      },
      "26": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "27": {
        start: {
          line: 70,
          column: 19
        },
        end: {
          line: 70,
          column: 41
        }
      },
      "28": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 60
        }
      },
      "29": {
        start: {
          line: 72,
          column: 17
        },
        end: {
          line: 72,
          column: 60
        }
      },
      "30": {
        start: {
          line: 73,
          column: 11
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "31": {
        start: {
          line: 74,
          column: 19
        },
        end: {
          line: 74,
          column: 39
        }
      },
      "32": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 59
        }
      },
      "33": {
        start: {
          line: 76,
          column: 17
        },
        end: {
          line: 76,
          column: 59
        }
      },
      "34": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 89,
          column: 3
        }
      },
      "35": {
        start: {
          line: 82,
          column: 25
        },
        end: {
          line: 82,
          column: 58
        }
      },
      "36": {
        start: {
          line: 83,
          column: 7
        },
        end: {
          line: 89,
          column: 3
        }
      },
      "37": {
        start: {
          line: 83,
          column: 28
        },
        end: {
          line: 83,
          column: 59
        }
      },
      "38": {
        start: {
          line: 84,
          column: 7
        },
        end: {
          line: 89,
          column: 3
        }
      },
      "39": {
        start: {
          line: 84,
          column: 28
        },
        end: {
          line: 84,
          column: 59
        }
      },
      "40": {
        start: {
          line: 85,
          column: 7
        },
        end: {
          line: 89,
          column: 3
        }
      },
      "41": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 47
        }
      },
      "42": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 77
        }
      },
      "43": {
        start: {
          line: 88,
          column: 20
        },
        end: {
          line: 88,
          column: 77
        }
      },
      "44": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 129,
          column: 4
        }
      },
      "45": {
        start: {
          line: 123,
          column: 26
        },
        end: {
          line: 123,
          column: 48
        }
      },
      "46": {
        start: {
          line: 132,
          column: 0
        },
        end: {
          line: 132,
          column: 30
        }
      },
      "47": {
        start: {
          line: 134,
          column: 0
        },
        end: {
          line: 136,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 29
          },
          end: {
            line: 19,
            column: 30
          }
        },
        loc: {
          start: {
            line: 19,
            column: 39
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 19
      },
      "1": {
        name: "RepositoryForm",
        decl: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 39,
            column: 23
          }
        },
        loc: {
          start: {
            line: 39,
            column: 26
          },
          end: {
            line: 130,
            column: 1
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 26
          }
        },
        loc: {
          start: {
            line: 46,
            column: 36
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 46
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 68,
            column: 35
          },
          end: {
            line: 68,
            column: 36
          }
        },
        loc: {
          start: {
            line: 68,
            column: 55
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 68
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 21
          }
        },
        loc: {
          start: {
            line: 123,
            column: 26
          },
          end: {
            line: 123,
            column: 48
          }
        },
        line: 123
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 51,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 51,
            column: 33
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 51,
            column: 33
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 39
          }
        }, {
          start: {
            line: 56,
            column: 43
          },
          end: {
            line: 56,
            column: 62
          }
        }],
        line: 56
      },
      "2": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 64,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 64,
            column: 22
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 64,
            column: 22
          }
        }],
        line: 58
      },
      "3": {
        loc: {
          start: {
            line: 59,
            column: 18
          },
          end: {
            line: 59,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 18
          },
          end: {
            line: 59,
            column: 28
          }
        }, {
          start: {
            line: 59,
            column: 32
          },
          end: {
            line: 59,
            column: 60
          }
        }],
        line: 59
      },
      "4": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 62,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 62,
            column: 34
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 62,
            column: 34
          }
        }],
        line: 61
      },
      "5": {
        loc: {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 34
          }
        }, {
          start: {
            line: 62,
            column: 9
          },
          end: {
            line: 62,
            column: 34
          }
        }],
        line: 62
      },
      "6": {
        loc: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 64,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 64,
            column: 22
          }
        }, {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 64,
            column: 22
          }
        }],
        line: 63
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 60
          }
        }, {
          start: {
            line: 72,
            column: 6
          },
          end: {
            line: 72,
            column: 60
          }
        }],
        line: 72
      },
      "9": {
        loc: {
          start: {
            line: 73,
            column: 11
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 11
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: 73,
            column: 11
          },
          end: {
            line: 77,
            column: 5
          }
        }],
        line: 73
      },
      "10": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 59
          }
        }, {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 59
          }
        }],
        line: 76
      },
      "11": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        }, {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        }],
        line: 82
      },
      "12": {
        loc: {
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }, {
          start: {
            line: 83,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }],
        line: 83
      },
      "13": {
        loc: {
          start: {
            line: 84,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }, {
          start: {
            line: 84,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }],
        line: 84
      },
      "14": {
        loc: {
          start: {
            line: 85,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }, {
          start: {
            line: 85,
            column: 7
          },
          end: {
            line: 89,
            column: 3
          }
        }],
        line: 85
      },
      "15": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 77
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 77
          }
        }],
        line: 88
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 24
          },
          end: {
            line: 108,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 37
          },
          end: {
            line: 108,
            column: 52
          }
        }, {
          start: {
            line: 108,
            column: 55
          },
          end: {
            line: 108,
            column: 57
          }
        }],
        line: 108
      },
      "17": {
        loc: {
          start: {
            line: 114,
            column: 24
          },
          end: {
            line: 114,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 114,
            column: 37
          },
          end: {
            line: 114,
            column: 59
          }
        }, {
          start: {
            line: 114,
            column: 62
          },
          end: {
            line: 114,
            column: 64
          }
        }],
        line: 114
      },
      "18": {
        loc: {
          start: {
            line: 119,
            column: 19
          },
          end: {
            line: 119,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 119,
            column: 32
          },
          end: {
            line: 119,
            column: 50
          }
        }, {
          start: {
            line: 119,
            column: 53
          },
          end: {
            line: 119,
            column: 58
          }
        }],
        line: 119
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "4a2c469e3759e5ac772718c52c1300cf1b6a0fd2"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _ = require("../..");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_1v150z5w6p.s[0]++, (0, _styles.makeStyles)(function (theme) {
  cov_1v150z5w6p.f[0]++;
  cov_1v150z5w6p.s[1]++;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: "".concat(theme.spacing(2), "px ").concat(theme.spacing(3), "px ").concat(theme.spacing(3), "px")
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing(1)
    },
    submit: {
      marginTop: theme.spacing(3)
    }
  };
}));

function RepositoryForm() {
  cov_1v150z5w6p.f[1]++;
  var classes = (cov_1v150z5w6p.s[2]++, useStyles());

  var _ref = (cov_1v150z5w6p.s[3]++, (0, _react.useState)({})),
      _ref2 = _slicedToArray(_ref, 2),
      formData = _ref2[0],
      setFormData = _ref2[1];

  var _ref3 = (cov_1v150z5w6p.s[4]++, (0, _react.useState)()),
      _ref4 = _slicedToArray(_ref3, 2),
      errorText = _ref4[0],
      setErrorText = _ref4[1];

  var _ref5 = (cov_1v150z5w6p.s[5]++, (0, _react.useContext)(_.AuthenticationContext)),
      authentication = _ref5.state;

  var _ref6 = (cov_1v150z5w6p.s[6]++, (0, _react.useContext)(_.RepositoryContext)),
      repository = _ref6.state,
      _ref6$actions = _ref6.actions,
      create = _ref6$actions.create,
      save = _ref6$actions.save;

  cov_1v150z5w6p.s[7]++;

  var updateFormData = function updateFormData(event) {
    cov_1v150z5w6p.f[2]++;

    var _ref7 = (cov_1v150z5w6p.s[8]++, event.target),
        type = _ref7.type,
        name = _ref7.name,
        value = _ref7.value,
        checked = _ref7.checked;

    var _formData = (cov_1v150z5w6p.s[9]++, _objectSpread({}, formData));

    cov_1v150z5w6p.s[10]++;

    if (type === 'checkbox') {
      cov_1v150z5w6p.b[0][0]++;
      cov_1v150z5w6p.s[11]++;
      _formData[value] = checked;
    } else {
      cov_1v150z5w6p.b[0][1]++;
      cov_1v150z5w6p.s[12]++;
      _formData[name] = value;
    }

    cov_1v150z5w6p.s[13]++;
    setFormData(_formData);
  };

  var mode;
  var authenticated = (cov_1v150z5w6p.s[14]++, (cov_1v150z5w6p.b[1][0]++, authentication) && (cov_1v150z5w6p.b[1][1]++, authentication.user));
  cov_1v150z5w6p.s[15]++;

  if (authenticated) {
    cov_1v150z5w6p.b[2][0]++;
    var admin = (cov_1v150z5w6p.s[16]++, (cov_1v150z5w6p.b[3][0]++, repository) && (cov_1v150z5w6p.b[3][1]++, repository.permissions.admin));
    cov_1v150z5w6p.s[17]++;

    if (!repository) {
      cov_1v150z5w6p.b[4][0]++;
      cov_1v150z5w6p.s[18]++;
      mode = 'create';
    } else {
      cov_1v150z5w6p.b[4][1]++;
      cov_1v150z5w6p.s[19]++;

      if (admin) {
        cov_1v150z5w6p.b[5][0]++;
        cov_1v150z5w6p.s[20]++;
        mode = 'edit';
      } else {
        cov_1v150z5w6p.b[5][1]++;
      }
    }
  } else {
    cov_1v150z5w6p.b[2][1]++;
    cov_1v150z5w6p.s[21]++;

    if (repository) {
      cov_1v150z5w6p.b[6][0]++;
      cov_1v150z5w6p.s[22]++;
      mode = 'view';
    } else {
      cov_1v150z5w6p.b[6][1]++;
      cov_1v150z5w6p.s[23]++;
      mode = 'error';
    }
  }

  var disabled = (cov_1v150z5w6p.s[24]++, mode === 'view');
  var handleSubmit = (cov_1v150z5w6p.s[25]++, (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings) {
      var repo, _repo;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cov_1v150z5w6p.f[3]++;
              cov_1v150z5w6p.s[26]++;

              if (!(mode === 'create')) {
                _context.next = 12;
                break;
              }

              cov_1v150z5w6p.b[7][0]++;
              cov_1v150z5w6p.s[27]++;
              _context.next = 7;
              return create(settings);

            case 7:
              repo = _context.sent;
              cov_1v150z5w6p.s[28]++;

              if (!repo) {
                cov_1v150z5w6p.b[8][0]++;
                cov_1v150z5w6p.s[29]++;
                setErrorText('Error creating repository.');
              } else {
                cov_1v150z5w6p.b[8][1]++;
              }

              _context.next = 25;
              break;

            case 12:
              cov_1v150z5w6p.b[7][1]++;
              cov_1v150z5w6p.s[30]++;

              if (!(mode === 'edit')) {
                _context.next = 24;
                break;
              }

              cov_1v150z5w6p.b[9][0]++;
              cov_1v150z5w6p.s[31]++;
              _context.next = 19;
              return save(settings);

            case 19:
              _repo = _context.sent;
              cov_1v150z5w6p.s[32]++;

              if (!_repo) {
                cov_1v150z5w6p.b[10][0]++;
                cov_1v150z5w6p.s[33]++;
                setErrorText('Error editing repository.');
              } else {
                cov_1v150z5w6p.b[10][1]++;
              }

              _context.next = 25;
              break;

            case 24:
              cov_1v150z5w6p.b[9][1]++;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref8.apply(this, arguments);
    };
  }(), [create, mode, save]));
  var actionText;
  cov_1v150z5w6p.s[34]++;

  if (mode === 'create') {
    cov_1v150z5w6p.b[11][0]++;
    cov_1v150z5w6p.s[35]++;
    actionText = 'Create Repository';
  } else {
    cov_1v150z5w6p.b[11][1]++;
    cov_1v150z5w6p.s[36]++;

    if (mode === 'edit') {
      cov_1v150z5w6p.b[12][0]++;
      cov_1v150z5w6p.s[37]++;
      actionText = 'Edit Repository';
    } else {
      cov_1v150z5w6p.b[12][1]++;
      cov_1v150z5w6p.s[38]++;

      if (mode === 'view') {
        cov_1v150z5w6p.b[13][0]++;
        cov_1v150z5w6p.s[39]++;
        actionText = 'View Repository';
      } else {
        cov_1v150z5w6p.b[13][1]++;
        cov_1v150z5w6p.s[40]++;

        if (mode === 'error') {
          cov_1v150z5w6p.b[14][0]++;
          cov_1v150z5w6p.s[41]++;
          actionText = 'View/Edit/Create Repository';
          cov_1v150z5w6p.s[42]++;

          if (!errorText) {
            cov_1v150z5w6p.b[15][0]++;
            cov_1v150z5w6p.s[43]++;
            setErrorText('Please login and/or provide a repository');
          } else {
            cov_1v150z5w6p.b[15][1]++;
          }
        } else {
          cov_1v150z5w6p.b[14][1]++;
        }
      }
    }
  }

  cov_1v150z5w6p.s[44]++;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar
  }, /*#__PURE__*/_react.default.createElement(_icons.FolderShared, null)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h1",
    variant: "h5"
  }, actionText), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    style: {
      color: 'red'
    }
  }, errorText), /*#__PURE__*/_react.default.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "name",
    label: "Name",
    type: "text",
    required: true,
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    onChange: updateFormData,
    helperText: "Name must be alpha-numeric and not include spaces.",
    disabled: disabled,
    defaultValue: repository ? (cov_1v150z5w6p.b[16][0]++, repository.name) : (cov_1v150z5w6p.b[16][1]++, '')
  }), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "description",
    label: "Description",
    type: "text",
    variant: "outlined",
    margin: "normal",
    fullWidth: true,
    onChange: updateFormData,
    disabled: disabled,
    defaultValue: repository ? (cov_1v150z5w6p.b[17][0]++, repository.description) : (cov_1v150z5w6p.b[17][1]++, '')
  }), /*#__PURE__*/_react.default.createElement(_.FormCheckbox, {
    name: "private",
    label: "Private",
    onChange: updateFormData,
    disabled: disabled,
    checked: repository ? (cov_1v150z5w6p.b[18][0]++, repository.private) : (cov_1v150z5w6p.b[18][1]++, false)
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    type: "button",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    className: classes.submit,
    disabled: disabled,
    onClick: function onClick() {
      cov_1v150z5w6p.f[4]++;
      cov_1v150z5w6p.s[45]++;
      return handleSubmit(formData);
    }
  }, actionText)));
}

cov_1v150z5w6p.s[46]++;
RepositoryForm.propTypes = {};
cov_1v150z5w6p.s[47]++;
RepositoryForm.defaultProps = {
  actionText: 'Repository Settings'
};
var _default = RepositoryForm;
exports.default = _default;